import { render, staticRenderFns } from "./outSideList.vue?vue&type=template&id=3565f4b6&"
import script from "./outSideList.vue?vue&type=script&lang=js&"
export * from "./outSideList.vue?vue&type=script&lang=js&"
import style0 from "./outSideList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports